export enum SIGNUP_REQUIREMENT {
    PASSWORD_SET = 'password_set',
    VERIFIED_PHONE = 'verified_phone',
    // PRIMARY_JOB = 'primary_job',
    // PAY_CYCLE = 'pay_cycle',
    // ESTIMATED_NET_PAY = 'estimated_net_pay',
}
